import LocalizationService from "services/localizationService";
import { action, computed, observable } from "mobx";
import { bound } from "@frui.ts/helpers";
import ScreenBase from "@frui.ts/screens/dist/structure/screenBase";
import { interfaces } from "inversify";

export default class GdprInfoViewModel extends ScreenBase {
  @observable isExpanded = false;

  constructor(private localizationService: LocalizationService) {
    super();
  }

  @action.bound
  toggle() {
    this.isExpanded = !this.isExpanded;
  }

  @bound
  translate(code: string) {
    return this.localizationService.translateGeneral(`eshop.order.gdpr.${code}`);
  }

  @computed
  get gdprLinkUrl() {
    return this.localizationService.translateGeneral("eshop.order.gdpr.linkUrl", undefined, true);
  }

  @computed
  get text2WithLink() {
    const text2 = this.translate("text2");
    return text2.replace("%linkUrl%", this.gdprLinkUrl);
  }

  static Factory({ container }: interfaces.Context) {
    return () => {
      return new GdprInfoViewModel(container.get(LocalizationService));
    };
  }
}
